<script setup lang="ts">
defineProps<{
  columns?: 2;
}>();
</script>

<template>
  <div class="zw-field-row">
    <slot />
  </div>
</template>

<style>
.zw-field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.85rem;
}

@media (max-width: 520px) {
  .zw-field-row {
    grid-template-columns: 1fr;
  }
}
</style>
